export const AGENCY_PRERENDER_JOB_STATUS = {
  CREATING: 'creating',
  QUEUED: 'queued',
  PROCESSING: 'processing',
  PROCESSED: 'processed',
  FAILED: 'failed',
  SKIPPED: 'skipped'
}

export const ACTIVE_PRERENDER_JOB_STATUSES = new Set([
  AGENCY_PRERENDER_JOB_STATUS.CREATING,
  AGENCY_PRERENDER_JOB_STATUS.QUEUED,
  AGENCY_PRERENDER_JOB_STATUS.PROCESSING
])

export const AGENCY_PRERENDER_DISPLAY_STATUS = {
  ready: { badgeClass: 'bg-success', icon: 'bi-check-circle-fill', label: 'Ready' },
  processing: { badgeClass: 'bg-warning text-dark', icon: 'spinner', label: 'Processing' },
  failed: { badgeClass: 'bg-danger', icon: 'bi-exclamation-triangle-fill', label: 'Failed' },
  skipped: { badgeClass: 'bg-secondary', icon: 'bi-dash-circle', label: 'Skipped' },
  incomplete: { badgeClass: 'bg-warning text-dark', icon: 'bi-exclamation-circle-fill', label: 'Incomplete' },
  missing: { badgeClass: 'bg-secondary', icon: 'bi-question-circle', label: 'Missing' }
}
